import { Text } from "@chakra-ui/react"
export { H1, H2, H3, H4, H5, H6 } from "./Headings"

export const Span = ({ ...rest }) => <Text as="span" variant="span" {...rest} />
export const Strong = ({ ...rest }) => <Span fontWeight="bold" {...rest} />
export const Em = ({ ...rest }) => <Span fontStyle="italic" {...rest} />
